export default "__VITE_ASSET__B79Td8w___"